import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useMyTranslations } from 'hooks/useMyTranslations';
import ParsersForm from 'components/Forms/ParsersForm/ParsersForm';
import { ParsersTableTransFields } from 'components/Tables/ParsersTable/types';
import { parsersTableTranslations } from 'components/Tables/ParsersTable/translations';
import styles from './addParser.module.scss';

const AddParser: FC = () => {
  const { t } = useMyTranslations<Extract<ParsersTableTransFields, 'addBtn'>>([parsersTableTranslations.name]);

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.headerTitle}>{t('addBtn')}</h2>
      </header>
      <div className={styles.container}>{<ParsersForm />}</div>
    </main>
  );
};

export default observer(AddParser);
